import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/modal";

/**
 * Custom confirmation dialog (replaces the native window.confirm) for
 * destructive actions — themed, dependency-free, reuses the shared Modal chrome.
 */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  onConfirm,
  onClose,
  busy = false,
}: {
  title: string;
  message: string;
  /** Confirm-button label; falls back to the shared "Delete" string. */
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  busy?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Modal title={title} onClose={onClose}>
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">{message}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={busy}>
            {t("actionPlans.actions.cancel")}
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {confirmLabel ?? t("actionPlans.actions.deleteComment")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
